import React, { Component } from "react";
import "./css/footer.css";

class Footer extends Component {
  state = {};
  render() {
    return (
      <footer className="footer">
        <div className="w-100 clearfix">
          <span className="footer-info"><i className="icon-earphones-alt icon-md"></i> +55 43 3304-2204</span>
          <span className="footer-info"><i className="icon-envelope-open icon-md"></i> atendimento@xbrain.com.br</span>
          <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">
            Copyright © 2018{" "}
            <a
              href="http://www.xbrain.com.br/"
              target="_blank"
              rel="noopener noreferrer"
            >
              X-Brain
            </a>
          </span>
        </div>
      </footer>
    );
  }
}

export default Footer;
